





























import {
  Component, Mixins,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Table from '@/components/Table/Index.vue';
import ActivityBody from '@/components/Table/ActiveBody.vue';
import ActivityData from '@/data/ActivityData';
import { IActivityLog } from '@/interface/Activity';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import ActivityModule from '@/store/modules/Activity';

@Component({
  components: {
    ActivityBody,
    Table,
  },
})
export default class AccessLog extends Mixins(
  ToolMixin, ErrorHandleMixin,
) {
  TableHeadActivity = ActivityData.TableHead;

  ActivityInstance = getModule(ActivityModule, this.$store);

  userData: Array<IActivityLog> = [
    {
      device: '',
      ipAddress: '',
      timestamp: '',
      role: '',
      username: '',
      type: '',
    },
  ]

  created() {
    this.fetchActivityLog();
  }

  async fetchActivityLog() {
    this.GeneralInstance.toggleLoading(true);
    const { data, status } = await this.ActivityInstance.FetchActivityLogAgent();
    if (status.code === 0 && data[0].username) {
      this.userData = data.sort((a: any, b: any) => b.timestamp - a.timestamp);
    } else if (status.code === 0 && !data[0].username) {
      this.userData = data;
    }
    if (status.code) this.checkError(status);
    this.GeneralInstance.toggleLoading(false);
  }
}
